import { HStack, IconButton, Icon, useColorModeValue } from "@chakra-ui/react";
import { List, LayoutGrid } from "lucide-react";

export type ViewMode = "kanban" | "lista";

export interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/** Alterna entre visualização em Kanban e em lista (accordion por status).
 * Puramente de apresentação — não afeta paginação/filtros/seleção, que
 * continuam vivendo nos hooks de cada seção/coluna. */
export const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
  const trackBg = useColorModeValue("white", "#0f2040");
  const trackBorder = useColorModeValue("gray.200", "whiteAlpha.200");
  const activeBg = useColorModeValue("ggBlue.900", "ggBlue.500");
  const inactiveColor = useColorModeValue("gray.400", "gray.500");
  const hoverBg = useColorModeValue("gray.100", "whiteAlpha.100");

  const options: { mode: ViewMode; label: string; icon: typeof List }[] = [
    { mode: "lista", label: "Visualização em lista", icon: List },
    { mode: "kanban", label: "Visualização em Kanban", icon: LayoutGrid },
  ];

  return (
    <HStack
      spacing="2px"
      bg={trackBg}
      borderWidth="1px"
      borderColor={trackBorder}
      borderRadius="full"
      p="3px"
      flexShrink={0}
    >
      {options.map(({ mode, label, icon }) => {
        const isActive = value === mode;
        return (
          <IconButton
            key={mode}
            aria-label={label}
            title={label}
            icon={<Icon as={icon} boxSize={4} />}
            size="sm"
            borderRadius="full"
            bg={isActive ? activeBg : "transparent"}
            color={isActive ? "white" : inactiveColor}
            _hover={{ bg: isActive ? activeBg : hoverBg }}
            onClick={() => onChange(mode)}
          />
        );
      })}
    </HStack>
  );
};
